import styled from "@emotion/styled";
import { motion } from "framer-motion";
import theme from "../../../theme";

const Subtitle = styled(motion.p)`
  color: ${theme.colors.text.tertiary};
  margin-bottom: 2rem;
  font-family: "Inter", sans-serif;
  @media (max-width: 480px) {
    font-size: 1rem;
    width: 95%;
  }
`;

const Form = styled(motion.form)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Input = styled(motion.input)`
  width: 95%;
  padding: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  font-family: "Inter", sans-serif;
  transition: border-color 0.2s;
  background: ${theme.colors.text.quaternary};
  border: 1px solid ${theme.colors.text.quinary};
  color: ${theme.colors.text.primary};

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
  @media (max-width: 768px) {
    width: 85%;
  }
  @media (max-width: 1024px) {
    width: 90%;
  }
  @media (max-width: 480px) {
    width: 85%;
  }
`;

const TextArea = styled(motion.textarea)`
  width: 95%;
  padding: 0.75rem;
  color: ${theme.colors.text.primary};
  background: ${theme.colors.text.quaternary};
  border: 1px solid ${theme.colors.text.quinary};
  border-radius: 10px;
  font-size: 14px;
  font-family: "Inter", sans-serif;
  transition: border-color 0.2s;
  min-height: 50px;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  @media (max-width: 768px) {
    width: 85%;
  }
  @media (max-width: 1024px) {
    width: 90%;
  }
  @media (max-width: 480px) {
    width: 85%;
  }
`;

const RecaptchaWrapper = styled.div`
  display: flex;
  width: 100%;

  @media (max-width: 768px) {
    transform: scale(0.85);
    transform-origin: center;
  }
`;

const SubmitButton = styled(motion.button)`
  background: ${theme.colors.gradient.themeGradient};
  color: white;
  padding: 0.75rem;
  border-radius: 10px;
  font-weight: 600;
  border: none;
  height: 45px;
  font-family: "Inter", sans-serif;
  cursor: pointer;
  width: 100%;
  text-align: center;

  &:hover {
    background-image: ${theme.colors.background.secondary};
  }

  &:disabled {
    background-color: ${theme.colors.border};
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    width: 90%;
  }
  @media (max-width: 1024px) {
    width: 90%;
  }
`;

const Label = styled(motion.p)`
  color: ${theme.colors.primary};
  margin-top: -0.5rem;
  font-size: 16px;
  font-family: "Inter", sans-serif;
`;

const Title = styled(motion.h2)`
  font-size: 40px;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1;
  font-family: "Inter", sans-serif;
  color: ${theme.colors.text.primary};

  span {
    color: ${theme.colors.text.secondary};
  }

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
  @media (max-width: 480px) {
    font-size: 1.5rem;
    width: 95%;
  }
`;

const Container = styled(motion.div)`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  border-radius: 25px;
  border: 1px solid ${theme.colors.text.quinary};
  overflow: hidden;
  background-color: ${theme.colors.white};

  @media (max-width: 1024px) {
    flex-direction: column;
    text-align: center;
  }
`;

const ImageContainer = styled(motion.div)`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Image = styled(motion.img)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const FormSection = styled(motion.div)`
  flex: 1;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  background: ${theme.colors.text.quaternary};
  border: 1px solid ${theme.colors.text.quinary};
  border-radius: 0px 25px 25px 0px;

  @media (max-width: 768px) {
    padding: 1rem;
  }
  @media (max-width: 480px) {
    font-size: 1.5rem;
    padding: 1rem;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const MainContainer = styled(motion.div)`
  padding: 50px;
  background-color: ${theme.colors.background.main};
  border-top: 0.2px solid ${theme.colors.text.quinary};
  border-image: linear-gradient(
      90deg,
      transparent,
      ${theme.colors.text.quinary} 50%,
      transparent
    )
    0.6;
  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const SC = {
  Container,
  ImageContainer,
  Image,
  FormSection,
  InputWrapper,
  Form,
  Input,
  TextArea,
  RecaptchaWrapper,
  SubmitButton,
  Label,
  Title,
  Subtitle,
  MainContainer,
};

export default SC;
